import PropTypes from 'prop-types';
import React from 'react';
import debounce from 'lodash/debounce';

import ReactEChartsCore from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { MapChart as EMapChart } from 'echarts/charts';
import { VisualMapComponent, TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import worldJson from '@ihme/common/web/components/MapChart/ihme-world.json';

import echartsTheme from '../../../../theme/echartsTheme';

echarts.use([EMapChart, VisualMapComponent, TitleComponent, CanvasRenderer]);

const propTypes = {
    data: PropTypes.array,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,

    isLoading: PropTypes.bool,
};

export default class View extends React.PureComponent {
    DEFAULT_ZOOM = 0.8;

    constructor(props) {
        super(props);

        this.state = {
            windowWidth: window.innerWidth,
            zoom: this.DEFAULT_ZOOM,
        };

        this.onResize = debounce(this.onResize.bind(this), 250);
    }

    componentDidMount() {
        echarts.registerMap('world', worldJson);
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        this.setState({ windowWidth: window.innerWidth });
    }

    render() {
        const { isLoading, title, subtitle, minValue, maxValue, data } = this.props;
        const { windowWidth, zoom } = this.state;

        return (
            <div style={{ pointerEvents: 'none' }}>
                <ReactEChartsCore
                    echarts={echarts}
                    showLoading={isLoading}
                    loadingOption={echartsTheme.loading}
                    theme={echartsTheme}
                    style={{
                        height: Math.min(Math.max(windowWidth / 2.4, 240), 490),
                        ...styles.container,
                    }}
                    option={{
                        title: {
                            text: title,
                            subtext: subtitle,
                        },

                        visualMap: {
                            show: false,
                            min: minValue,
                            max: maxValue,
                            ...styles.visualMap,
                        },
                        series: [
                            {
                                zoom,
                                data,
                                ...styles.chart,
                            },
                        ],
                    }}
                />
            </div>
        );
    }
}

const styles = {
    container: {
        width: '100%',
        margin: '0 0 20pt 0',
    },
    chart: {
        type: 'map',
        map: 'world',
        selectedMode: 'single',
        center: [500, 50],
        roam: 'move',
        top: 100,
        height: '90%',
        itemStyle: {
            borderWidth: 0.5,
            borderColor: 'white',
        },
    },
    visualMap: {
        realtime: true,
        calculable: true,
        top: 20,
        itemWidth: 6,
        itemHeight: 350,
        inRange: {
            color: [
                '#199949',
                '#20C05C',
                '#4CCC7C',
                '#82DBA3',
                '#FBDD39',
                '#F7B600',
                '#F18602',
                '#E86D0C',
            ],
        },
        outOfRange: {
            color: '#ECEFF1',
        },
    },
};

View.propTypes = propTypes;
